import request from '@/utils/request'
import { toCmsContent, mapPageResult, mapSingleResult } from './helpers'

// 首页研究方向 (HOME_RESEARCH_DIRECTION) - 用于首页卡片展示
export function getHomeResearchDirectionList () {
  return request.get('/api/cms/list', {
    params: { type: 'HOME_RESEARCH_DIRECTION', page: 1, pageSize: 100 }
  }).then(mapPageResult)
}

export function getHomeResearchDirectionDetail (id) {
  return request.get(`/api/cms/detail/${id}`).then(mapSingleResult)
}

export function addHomeResearchDirection (data) {
  return request.post('/api/cms', toCmsContent(data, 'HOME_RESEARCH_DIRECTION'))
}

export function updateHomeResearchDirection (data) {
  return request.put(`/api/cms/${data.id}`, toCmsContent(data, 'HOME_RESEARCH_DIRECTION'))
}

export function deleteHomeResearchDirection (id) {
  return request.delete(`/api/cms/${id}`)
}

// 科学研究-研究方向 (RESEARCH_DIRECTION) - 用于科学研究页面
export function getResearchDirectionList (params) {
  return request.get('/api/cms/list', {
    params: { ...params, type: 'RESEARCH_DIRECTION' }
  }).then(mapPageResult)
}

export function getResearchDetail (id) {
  return request.get(`/api/cms/detail/${id}`).then(mapSingleResult)
}

export function addResearchDirection (data) {
  return request.post('/api/cms', toCmsContent(data, 'RESEARCH_DIRECTION'))
}

export function updateResearchDirection (data) {
  return request.put(`/api/cms/${data.id}`, toCmsContent(data, 'RESEARCH_DIRECTION'))
}

export function deleteResearchDirection (id) {
  return request.delete(`/api/cms/${id}`)
}

// 科研项目 (RESEARCH_PROJECT)
export function getProjectList (params) {
  return request.get('/api/cms/list', {
    params: { ...params, type: 'RESEARCH_PROJECT' }
  }).then(mapPageResult)
}

export function getProjectDetail (id) {
  return request.get(`/api/cms/detail/${id}`).then(mapSingleResult)
}

export function addProject (data) {
  return request.post('/api/cms', toCmsContent(data, 'RESEARCH_PROJECT'))
}

export function updateProject (data) {
  return request.put(`/api/cms/${data.id}`, toCmsContent(data, 'RESEARCH_PROJECT'))
}

export function deleteProject (id) {
  return request.delete(`/api/cms/${id}`)
}

// 荣誉奖项 (RESEARCH_HONOR)
export function getHonorList (params) {
  return request.get('/api/cms/list', {
    params: { ...params, type: 'RESEARCH_HONOR' }
  }).then(mapPageResult)
}

export function getHonorDetail (id) {
  return request.get(`/api/cms/detail/${id}`).then(mapSingleResult)
}

export function addHonor (data) {
  return request.post('/api/cms', toCmsContent(data, 'RESEARCH_HONOR'))
}

export function updateHonor (data) {
  return request.put(`/api/cms/${data.id}`, toCmsContent(data, 'RESEARCH_HONOR'))
}

export function deleteHonor (id) {
  return request.delete(`/api/cms/${id}`)
}

// 科研项目页面内容（markdown渲染，取第一条的详情）
export function getProjectPageContent () {
  return request.get('/api/cms/list', {
    params: { type: 'RESEARCH_PROJECT', page: 1, pageSize: 1 }
  }).then(res => {
    if (res.code === 1 && res.data && res.data.rows && res.data.rows.length > 0) {
      const id = res.data.rows[0].id
      return request.get(`/api/cms/detail/${id}`).then(mapSingleResult)
    }
    return res
  })
}

// 学术成果页面内容（markdown渲染，取第一条的详情）
export function getAchievementPageContent () {
  return request.get('/api/cms/list', {
    params: { type: 'RESEARCH_ACHIEVEMENT', page: 1, pageSize: 1 }
  }).then(res => {
    if (res.code === 1 && res.data && res.data.rows && res.data.rows.length > 0) {
      const id = res.data.rows[0].id
      return request.get(`/api/cms/detail/${id}`).then(mapSingleResult)
    }
    return res
  })
}

// 荣誉奖项页面内容（markdown渲染，取第一条的详情）
export function getHonorPageContent () {
  return request.get('/api/cms/list', {
    params: { type: 'RESEARCH_HONOR', page: 1, pageSize: 1 }
  }).then(res => {
    if (res.code === 1 && res.data && res.data.rows && res.data.rows.length > 0) {
      const id = res.data.rows[0].id
      return request.get(`/api/cms/detail/${id}`).then(mapSingleResult)
    }
    return res
  })
}
